import {
  attributes,
  supportedAttributes,
  supportedClasses,
  breakpoints,
  breakpointNames,
  BREAKPOINT_ORDER,
} from '@yola/atomic-css-generator';
import operations from './operations';

export default {
  operations,
  constants: {
    attributes,
    supportedAttributes,
    supportedClasses,
    breakpoints,
    breakpointNames,
    BREAKPOINT_ORDER,
  },
};
